/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 09:45:58
 * @LastEditTime: 2019-08-22 10:13:58
 * @LastEditors: Please set LastEditors
 */
import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  var url = window.location.host
  var Domain = url.slice(url.indexOf('.'))
  if(process.env.NODE_ENV=='development'){
    
    return Cookies.set(TokenKey, token,{expires: 7})
  }
  if(url.split('.').length>2){
    return Cookies.set(TokenKey, token, { Domain: Domain,expires: 7})
  }else{
    return Cookies.set(TokenKey, token, { Domain: `.${url}`,expires: 7})
  }
}

export function removeToken() {
  var url = window.location.host
  var Domain = url.slice(url.indexOf('.'))
  if (process.env.NODE_ENV=='development'){
    return Cookies.remove(TokenKey)
  }

  if(url.split('.').length>2){
    return Cookies.remove(TokenKey, { Domain: Domain,path:'/'})
  }else{
    return Cookies.remove(TokenKey, { Domain: `.${url}`,path:'/'})
  }
}
export function removeLanguage(){
 Cookies.remove('language');
 Cookies.remove('languageName');
}


export function getCookie(name) {
  return Cookies.get(name)
}

export function setCookie(name,value) {
  var url = window.location.host
  var Domain = url.slice(url.indexOf('.'))
  if(process.env.NODE_ENV=='development'){
    return Cookies.set(name, value,{expires: 7})
  }

  if(url.split('.').length>2){
    return Cookies.set(name, value, { Domain: Domain,expires: 7})
  }else{
    return Cookies.set(name, value, { Domain: `.${url}`,expires: 7})
  }
}

export function removeCookie(name) {
  return Cookies.remove(name)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js